import React from 'react';
import AsyncSelect from "react-select/async";
import { useAppDispatch } from "../../../app/store";
import { ADMIN_LANG } from "../../../settings";
import { PlainDetails } from "../../../types/admin";
import { getPlainTeams } from "../../../app/slices/admin";

interface AsyncTeamsSelectProps {
    onChange: (value: PlainDetails[]) => void;
    initialValues: PlainDetails[];
    selectedTeams: PlainDetails[];
}

const AsyncTeamsSelect = ({ onChange, initialValues, selectedTeams }: AsyncTeamsSelectProps) => {
    const dispatch = useAppDispatch();

    const loadOptions = (input: string) => {
        return new Promise<PlainDetails[]>((resolve) => {
            if (input.length < 2) {
                return resolve([]);
            }

            dispatch(getPlainTeams(input))
                .then((fulfilledAction) => {
                    const data: PlainDetails[] = fulfilledAction.payload.teams;
                    resolve(data);
                })
                .catch(() => resolve([]));
        });
    };

    return (
        <AsyncSelect
            value={selectedTeams}
            cacheOptions
            defaultOptions={initialValues.length > 0 ? initialValues : undefined}
            isMulti
            loadOptions={loadOptions}
            noOptionsMessage={() => ADMIN_LANG.search}
            onChange={(selectedValues) => onChange(selectedValues as PlainDetails[])}
            placeholder={ADMIN_LANG.select_teams}
            classNamePrefix="react-select"
            className="custom-react-select"
        />
    );
};

export default AsyncTeamsSelect;